import {RouteContext} from "../../../RouteContext";
import {ListPage} from "../../common/ListPage";
import React from "react";
import {Column} from "../../common/Layout";
import {ShoppingPathJointFileIO} from "../../../../io/content/ShoppingPathJointFileIO";
import {ShoppingPathJointFileValueObject} from "../../../../model/vo/content/ShoppingPathJointFileValueObject";
import TruncateText from "../../common/TruncateText";


export default function List(props: RouteContext) {

        return <>
        <Column gap={'16px'}>
            <ListPage
                {...props}
                description={ShoppingPathJointFileValueObject.description}
                list={ShoppingPathJointFileIO.list}
                count={ShoppingPathJointFileIO.count}
                delete={ShoppingPathJointFileIO.delete}
                postHref={'/admin/shoppings/pathJointFiles'}
                detailHref={item => `/admin/shoppings/pathJointFiles/${item.id}`}
                editHref={item => `/admin/shoppings/pathJointFiles/edit/${item.id}`}
                itemValue={(item, key) => {
                    if(key === 'fileUrl'){
                        return <TruncateText text={item[key] || ''} maxLength={20}/>
                    }
                    else {
                        return undefined
                    }
                }}
                initialSearchConditions={[
                    {
                        name: 'deletedAt',
                        value: '',
                        condition: 'IsNull'
                    },
                ]}
            />
        </Column>
    </>
}